import React, { useCallback, useMemo, useState } from "react"
import { AddTaskButton } from "../AddTaskButton"
import { DatePicker } from "../DatePicker"
import { FilterModal } from "../FilterModal"
import { HeaderBar } from "../HeaderBar"
import { Box } from "../gluestack/box"
import { TaskList } from "./TaskList"

interface TasksMobileProps {
  currentDate: string
  onCurrentDateChange: (date: string) => void
}

export const TasksMobile: React.FC<TasksMobileProps> = ({
  currentDate,
  onCurrentDateChange,
}) => {
  const [isDatePickerVisible, setIsDatePickerVisible] = useState(false)
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false)

  // Memoize event handlers
  const handleDatePress = useCallback(() => {
    setIsDatePickerVisible(true)
  }, [])

  const handleFilterPress = useCallback(() => {
    setIsFilterModalVisible(true)
  }, [])

  const handleDateSelect = useCallback(
    (date: string) => {
      onCurrentDateChange(date)
    },
    [onCurrentDateChange],
  )

  const handleDatePickerClose = useCallback(() => {
    setIsDatePickerVisible(false)
  }, [])

  const handleFilterModalClose = useCallback(() => {
    setIsFilterModalVisible(false)
  }, [])

  // Memoize Date object creation
  const headerDate = useMemo(() => new Date(currentDate), [currentDate])

  return (
    <Box className="flex-1">
      <HeaderBar
        date={headerDate}
        onDatePress={handleDatePress}
        onFilterPress={handleFilterPress}
      />

      <TaskList
        currentDate={currentDate}
        onCurrentDateChange={onCurrentDateChange}
      />

      <DatePicker
        isVisible={isDatePickerVisible}
        onClose={handleDatePickerClose}
        onDateSelect={handleDateSelect}
        selectedDate={currentDate}
        explicitSelectRequired={true}
        showTaskIndicators={true}
      />

      <FilterModal
        isVisible={isFilterModalVisible}
        onClose={handleFilterModalClose}
      />

      <AddTaskButton date={currentDate} />
    </Box>
  )
}
